import { render, staticRenderFns } from "./IP2LRangeComp.vue?vue&type=template&id=244cf622&"
import script from "./IP2LRangeComp.vue?vue&type=script&lang=js&"
export * from "./IP2LRangeComp.vue?vue&type=script&lang=js&"
import style0 from "./IP2LRangeComp.vue?vue&type=style&index=0&id=244cf622&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports